import { switchAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(switchAnatomy.keys);

const iosStyle = definePartsStyle((props) => {
  const { colorScheme } = props;

  if (!["mi1Result", "mentalActivity", "vitality"].includes(colorScheme)) {
    return {
      thumb: {
        bg: "white",
      },
    };
  }

  return {
    track: {
      bg: `${colorScheme}.bg`,
      _checked: {
        bg: `${colorScheme}.primary`,
      },
    },
    thumb: {
      bg: "white",
    },
  };
});

export const SwitchStyle = defineMultiStyleConfig({
  variants: {
    ios: iosStyle,
  },
  defaultProps: {
    variant: "ios",
  },
});
